import { PathType } from "./PathType";
import Home from '../../../../../assets/home.svg';
import Home_Active from '../../../../../assets/home_active.svg';
import Mediacal_emergency from '../../../../../assets/pulse_alert.svg';
import Mediacal_emergency2 from '../../../../../assets/pulse_alert_active.svg';
import User from '../../../../../assets/history.svg';
import User_Active from '../../../../../assets/history_active.svg';
import admin from '../../../../../assets/admin.png';
import Role from '../../../../../assets/role.png';
import Flights from "../../../body/screens/IAM/Flights/Flights";
import { startInactiveSpan } from "@sentry/react";
import inActiveFlights from '../../../../../assets/inActiveFlights.svg'
import ActivePane from '../../../../../assets/ActivePane.svg'
import UserActivity from '../../../../../assets/userActivity.svg'
import activeUserActivity from '../../../../../assets/user_activity.svg'
import Active from '../../../../../assets/browse_activity.svg'
import inActive from '../../../../../assets/medicalKit_InActive.svg'
import ActiveM from '../../../../../assets/medicalKit_Active.svg'
import passenger from '../../../../../assets/Group 2858.svg'
import passenger_active from "../../../../../assets/Group 2858 (1).svg"
import form from "../../../../../assets/form.svg";
import form_active from "../../../../../assets/form(2).svg";

export const SkaliPaths: PathType[] = [

  {
    path: "/home",
    label: "Home",
    icon: Home,
    icon_active: Home_Active
  },
  {
    path: "/ems/medical-emergencies",
    label: "Active Incidents",
    icon: Mediacal_emergency,
    icon_active: Mediacal_emergency2
  },
  {
    path: "/users",
    label: "Users",
    icon: User,
    icon_active: User_Active
  },
  // {
  //   path: "/user-activity",
  //   label: "UserActivity",
  //   icon: activeUserActivity,
  //   icon_active: UserActivity,
  // },
  {
    path: "/flights",
    label: "Flights",
    icon: inActiveFlights ,
    icon_active: ActivePane
  },
  {
    path: "/medicalkit",
    label: "Medical Kit",
    icon: inActive ,
    icon_active: ActiveM
  },
  {
    path: "/passengers",
    label: "Passengers",
    icon: passenger,
    icon_active: passenger_active
  },
  // {
  //   path: "/MedicalEventReportFormList",
  //   label: "Medical Event Report",
  //   icon: form,
  //   icon_active:form_active
  // }

  // {
  //   path: "/FitToFlyflow",
  //   label: "Fit To Fly Flow",
  //   icon: form,
  //   icon_active:form_active
  // }
];
